import styled from 'particles/themes/styled'
import { theme } from 'theme'

interface SearchBarContainerProps {
    isExpanded: boolean
    width: string
    height: string
    padding: string
    background: string
}

export const InnerContainer = styled.div`
    max-height: 100%;
    overflow-y: auto;
    width: 100%;
    padding: ${theme.newSpacing.m} ${theme.newSpacing.l};
    box-sizing: border-box;
`
export const SearchBarContainer = styled.div<SearchBarContainerProps>`
    width: ${({ isExpanded, width }) => (isExpanded ? width : '84px')};
    max-width: ${({ isExpanded, width }) => (isExpanded ? width : 'fit-content')};
    height: ${({ height }): string => height};
    padding: ${({ padding }): string => padding};
    border: ${({ isExpanded }) => (isExpanded ? `1px solid ${theme.newColors.neutral200}` : 'none')};
    border-radius: 4px;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    background: ${({ background }): string => background};
    transition: all 0.5s;
    gap: 8px;
    @media screen and (max-width: 375px) {
        min-width: 100%;
    }
    @media screen and (max-width: 480px) {
        width: calc(100% - 2rem);
    }

    .search-icon {
        display: flex;
    }

    .submit-form {
        display: flex;
        align-items: center;
        width: ${({ isExpanded }) => (isExpanded ? '100%' : 'auto')};
        max-width: 100%;
        gap: 8px;
        input {
            font-size: 1rem;
            all: unset;
            width: ${({ isExpanded }) => (isExpanded ? '100%' : '0')};
            max-width: 100%;
            display: ${({ isExpanded }) => (isExpanded ? 'block' : 'none')};
            &::placeholder {
                color: ${theme.newColors.neutral400};
                font-size: ${theme.newFontSizes.s};
                font-weight: ${theme.fontWeight.regular};
                line-height: ${theme.lineHeight.m};
            }
        }

        input:-webkit-autofill,
        input:-webkit-autofill:hover,
        input:-webkit-autofill:focus,
        input:-webkit-autofill:active {
            -webkit-box-shadow: 0 0 0 30px ${theme.newColors.neutral50} inset !important;
        }

        input:placeholder-shown {
            text-overflow: ellipsis;
        }
    }
    .search-button {
        width: fit-content;
        min-width: 52px;
        all: unset;
        white-space-collapse: collapse;
        text-wrap: nowrap;
        text-align: center;
        cursor: pointer;
    }
`

export const IconTextContainer = styled.div`
    display: flex;
    flex-direction: row;
    .icon {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: ${theme.newSpacing.xxxxs};
    }
`
